import "../../Home/styles/VideoSection.css";
import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import Arrowleft from "../../../assets/icons/left_arrow_black.svg";
import Arrowright from "../../../assets/icons/right_arrow_black.svg";
import { useObsessionsinAction } from "../hooks/useObsessionsinAction";

function ObsessionsinAction() {
  const {
    sliderRef,
    videoRefs,
    galleries,
    loopList,
    activeIndex,
    playingIndex,
    scroll,
    handlePlay,
    togglePause,
    closeReel,
  } = useObsessionsinAction();

  return (
    <section className="video-section" id="reels">
       <div className="video-header">
        <h2 className="video-heading">
          <span className="track_ost">Obsessions in</span> <em>Action</em>
        </h2>
        <p className="txt_sub_video_tag">
          See how our products blend into real homes, real moods, and real lifestyles.
        </p>

        <Link to="/reels">
          <button className="hero-button">VIEW THE GALLERY</button>
        </Link>
      </div>

      <div className="video-slider-wrapper">
        <div className="video-slider" ref={sliderRef}>
          {loopList.map((video, index) => (
            <div className="video-card" key={index}>
              <div className="video-wrapper">
                
                {/* VIDEO */}

                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={video.uploaded_media}
                  poster={video.poster_image}
                  controls={playingIndex === index}
                  playsInline
                  muted
                  preload="metadata"
                  onClick={() => togglePause(index)}

                  // CRITICAL FIX (STOP OTHER VIDEOS)
                  onPlay={() => {
                    videoRefs.current.forEach((vid, i) => {
                      if (i !== index && vid) {
                        vid.pause();
                        vid.currentTime = 0;
                      }
                    });
                    handlePlay(index);
                  }}
                />

                {/* PLAY BUTTON */}
                {playingIndex !== index && (
                  <div
                    className="video-icon-container-dil"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePlay(index);
                    }}
                  >
                    <FaPlay style={{ color:"#FFF"}} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* ARROWS */}
            <div className="slider-controls">
          <div className="arrow-controls">
            <button className="btn_arrow left" onClick={() => scroll("left")}>
              <img src={Arrowleft} alt="prev" className="arrow-img" />
            </button>
            <button className="btn_arrow right" onClick={() => scroll("right")}>
              <img src={Arrowright} alt="next" className="arrow-img" />
            </button>
          </div>
        </div>
      </div>
     

      {/* REEL VIEWER */}
      {activeIndex !== null && (
        <div className="reel-viewer">
          <button onClick={closeReel}>✕</button>

          {galleries.map((video, index) => (
            <video
              key={index}
              src={video.uploaded_media}
              poster={video.poster_image}
              controls
              autoPlay={index === activeIndex}
            />
          ))}
        </div>
      )}
    </section>
  );
}
export default ObsessionsinAction;